import { render } from "./GrowthInflectionAnalysis.vue?vue&type=template&id=34f2c0a4"
import script from "./GrowthInflectionAnalysis.vue?vue&type=script&lang=js"
export * from "./GrowthInflectionAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__